import "./NomoreTemplets.css";
"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _component = require("../_utils/component");

var _Udesk = _interopRequireDefault(require("../Udesk"));

var _vueNormalizeComponent = _interopRequireDefault(require("../_utils/vue-normalize-component.js"));

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var __vue_script__ = {
  name: (0, _component.createComponentName)('nomore-templets'),
  components: {
    Udesk: _Udesk.default
  },
  mixins: [_component.componentMixin],
  props: {
    // udesk 配置
    config: {
      type: Object,

      default() {
        return {};
      }

    }
  },

  data() {
    return {};
  },

  methods: {}
};
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c("div", {
    class: _vm.bem("nomore-templets")
  }, [_c("div", {
    class: _vm.bem("text")
  }, [_vm._v("\n        没有更多了\n    ")]), _vm._v(" "), _c("div", {
    class: _vm.bem("feedback")
  }, [_vm._v("\n        没有找到想要的模板？\n        "), _c("udesk", {
    attrs: {
      config: _vm.config
    }
  }, [_c("div", {
    class: _vm.bem("udesk"),
    on: {
      click: function click($event) {
        return _vm.$emit("showUdesk");
      }
    }
  }, [_c("div", {
    class: _vm.bem("feedback-icon")
  }), _vm._v("\n                反馈给我们\n            ")])])], 1)]);
};

var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

/* style inject */

/* style inject SSR */
var _default = (0, _vueNormalizeComponent.default)({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);

exports.default = _default;